import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirestore } from 'react-redux-firebase';
import { updateProfile } from '../../../store/actions/companyActions';
import { deleteAccount } from '../../../store/actions/userProfileActions';
import { resetAccount } from '../../../store/actions/authActions';

const styles = theme => ({
  layout: {
    width: '100%',
    background: '#f5f6fa',
    paddingTop: theme.spacing.unit * 7,
    paddingBottom: theme.spacing.unit * 10,
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4,
    [theme.breakpoints.up(600 + theme.spacing.unit * 4 * 2)]: {
      boxSizing: 'border-box'
    }
  },
  root: {
    width: '100%',
    minHeight: '500px'
  },
  leftPageDiv: {
    width: '250px',
    overflow: 'hidden',
    minHeight: '50px',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  otherPage: {
    padding: '20px',
    width: '100%'
  },
  profile_info: {
    padding: 0
  },
  profile_info_delete: {
    padding: 0,
    marginTop: '50px'
  },
  profile__header: {
    background: '#e7e8ea',
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 30,
    paddingRight: 30
  },
  profileContent: {
    position: 'relative'
  },
  section: {
    paddingTop: 15,
    paddingBottom: 40,
    paddingLeft: 30,
    paddingRight: 30
  },
  deleteCancelButtons: {
    width: '85px'
  },
  deleteAcceptButtons: {
    width: '85px',
    float: 'right'
  },
  deleteButtonsContainer: {
    marginTop: '50px'
  },
  button: {
    color: '#ffffff'
  },
  listIcon: {
    minWidth: '36px'
  },
  settingsOverlay: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    background: 'white',
    zIndex: 10,
    opacity: '.5'
  },
  resetPasswordButton: {
    color: 'white'
  }
});

const mapStateToProps = state => {
  return {
    profile: state.firebase.profile,
    auth: state.firebase.auth
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    handleUpdateProfile: newProfile => dispatch(updateProfile(newProfile)),
    handleDeleteAccount: newProfile => dispatch(deleteAccount(newProfile)),
    resetAccountClickHandler: email => dispatch(resetAccount(email))
  };
};

export default compose(
  withFirestore,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withRouter,
  withProps(({ auth, profile }) => ({
    auth,
    profile
    // campaigns
  })),
  withStyles(styles),
  // Add props.router (used in handlers)
  withRouter
);



// WEBPACK FOOTER //
// ./src/components/company/settings/CompanySettings.enhancer.js